import React from "react";

import { ArrowIcon } from "@common/arrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Project(props: Props) {
  return (
    <div className={styles.project}>
      <h2 className={styles.name}>{props.project.name}</h2>
      <div className={styles.iconBox}>
        <ArrowIcon className={styles.icon} />
      </div>
    </div>
  );
}

export { Project };
